import { FormControl } from '@angular/forms';
//checks type NgbDateStruct, ex: {year: 2018, month: 4, day: 7}
export function ValidateNegativeNumber(c: FormControl) {
    const reg = /^\d+$/;

    const isVallid = reg.test(c.value);
    return isVallid ? null : { 'negativeNumber': true };
    // let validNegative = false;
    // if (c.value) {
    //     if (c.value < 0) {
    //         validNegative = false;
    //     }
    //     else {
    //         validNegative = true;
    //     }
    // }
    // return validNegative === false ? { invalidNumber: true } : null;
}


// WEBPACK FOOTER //
// ./src/app/negative-number-validator.ts